import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Globe, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function Countries() {
  const [countries, setCountries] = useState([]);
  useEffect(() => { api.get("/public/countries").then((r) => setCountries(r.data)).catch(() => {}); }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 md:px-6">
      <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">Browse by Country</h1>
      <p className="mt-1 text-slate-500">Explore online programmes offered by universities around the world</p>
      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {countries.map((c) => (
          <Link key={c.id} to={`/countries/${c.slug}`} data-testid={`country-${c.slug}`}
            className="group flex items-center justify-between rounded-xl border border-slate-200 bg-white p-6 transition-all hover:shadow-md">
            <div>
              <div className="flex items-center gap-2">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-blue-800"><Globe className="h-5 w-5" /></span>
                <h3 className="font-heading text-lg font-semibold text-slate-900 group-hover:text-blue-800">{c.name}</h3>
              </div>
              <p className="mt-3 text-sm text-slate-500">{c.institution_count} universities · {c.course_count} programmes</p>
            </div>
            <ArrowRight className="h-5 w-5 text-slate-300 transition group-hover:translate-x-1 group-hover:text-blue-800" />
          </Link>
        ))}
      </div>
    </div>
  );
}
